import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgErrorPageIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 148,
	height: 176,
	viewBox: "0 0 148 176",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M73.3212 87.2231L147.074 43.6328L73.7524 0.265564L0 43.6328L73.3212 87.2231Z",
			fill: "#ECF2F9"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M73.2545 82.4526L138.145 43.8831L73.6339 5.51105L8.74341 43.8831L73.2545 82.4526Z",
			fill: "#FDFEFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M73.4441 82.4526V5.51105L138.145 43.9818L73.4441 82.4526Z",
			fill: "#1F2537"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M73.4441 82.4526V5.51105L8.74328 43.9818L73.4441 82.4526Z",
			fill: "#373D51"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.5837 0C47.3094 0 24.3884 22.9208 24.3884 51.1952C24.3884 79.4697 47.3094 102.39 75.5837 102.39C103.858 102.39 126.779 79.4694 126.779 51.1952C126.779 22.921 103.858 0 75.5837 0ZM102.442 24.3367C115.953 37.8473 116.892 58.4974 106.711 72.9798L53.7988 20.0685C68.2912 9.87985 88.939 10.8338 102.442 24.3367ZM48.7252 78.0537C35.2146 64.5431 34.2749 43.8931 44.4568 29.4106L97.3685 82.3219C82.8763 92.5106 62.2283 91.5569 48.7252 78.0537Z",
			fill: "#9C9FAF"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_i_3270_9851)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M74.4953 3.2674C46.2211 3.2674 23.3 26.1882 23.3 54.4626C23.3 82.737 46.2211 105.658 74.4953 105.658C102.769 105.658 125.691 82.7368 125.691 54.4626C125.691 26.1884 102.77 3.2674 74.4953 3.2674ZM101.354 27.6041C114.864 41.1147 115.804 61.7648 105.622 76.2472L52.7105 23.3359C67.2028 13.1472 87.8506 14.1012 101.354 27.6041ZM47.6368 81.3211C34.1262 67.8105 33.1865 47.1605 43.3684 32.678L96.2801 85.5893C81.7879 95.778 61.1399 94.8243 47.6368 81.3211Z",
				fill: "#FDFEFF"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0 43.6326V130.968L73.7524 175.133V87.2228L0 43.6326Z",
			fill: "#E5E6EB"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M147.073 43.6326V130.968L73.3211 175.133V87.2228L147.073 43.6326Z",
			fill: "#9C9FAF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M73.4246 82.4375L32.4614 58.0911V62.8801L73.4246 87.0875L110.618 65.1586V60.3543L73.4246 82.4375Z",
			fill: "#ECF2F9"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_i_3270_9851",
			x: 23.3,
			y: 3.2674,
			width: 102.39,
			height: 103.39,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "arithmetic",
					k2: -1,
					k3: 1
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0705882 0 0 0 0 0.0941176 0 0 0 0 0.121569 0 0 0 0.07 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "shape",
					result: "effect1_innerShadow_3270_9851"
				})
			]
		}) })
	]
});
export default SvgErrorPageIcon;
